import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const Inbox = lazyRouteComponent(() => import('../../pages/profile/inbox'))

export const inboxRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'inbox',
  component: Inbox,
})
